import { render, staticRenderFns } from "./deletebeOffice.vue?vue&type=template&id=b71e614e&scoped=true"
import script from "./deletebeOffice.vue?vue&type=script&lang=js"
export * from "./deletebeOffice.vue?vue&type=script&lang=js"
import style0 from "./deletebeOffice.vue?vue&type=style&index=0&id=b71e614e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b71e614e",
  null
  
)

export default component.exports